import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "translate-dialog__wrapper" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcSelect = _resolveComponent("NcSelect")
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")
  const _component_NcLoadingIcon = _resolveComponent("NcLoadingIcon")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NcRichText = _resolveComponent("NcRichText")
  const _component_IconContentCopy = _resolveComponent("IconContentCopy")
  const _component_NcDialog = _resolveComponent("NcDialog")

  return (_openBlock(), _createBlock(_component_NcDialog, {
    class: "translate-dialog",
    name: $options.t('spreed', 'Translate message'),
    size: "large",
    "close-on-click-outside": "",
    "onUpdate:open": _cache[2] || (_cache[2] = $event => (_ctx.$emit('close')))
  }, _createSlots({ _: 2 }, [
    ($data.isMounted)
      ? {
          name: "default",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_NcSelect, {
                modelValue: $data.selectedFrom,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.selectedFrom) = $event)),
                class: "translate-dialog__select",
                "input-id": "from",
                "aria-label-combobox": $options.t('spreed', 'Source language to translate from'),
                placeholder: $options.t('spreed', 'Translate from'),
                options: $options.optionsFrom,
                "no-wrap": ""
              }, null, 8, ["modelValue", "aria-label-combobox", "placeholder", "options"]),
              _createVNode(_component_IconArrowRight, { class: "bidirectional-icon" }),
              _createVNode(_component_NcSelect, {
                modelValue: $data.selectedTo,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.selectedTo) = $event)),
                class: "translate-dialog__select",
                "input-id": "to",
                "aria-label-combobox": $options.t('spreed', 'Target language to translate into'),
                placeholder: $options.t('spreed', 'Translate to'),
                options: $options.optionsTo,
                "no-wrap": ""
              }, null, 8, ["modelValue", "aria-label-combobox", "placeholder", "options"]),
              _createVNode(_component_NcButton, {
                variant: "primary",
                disabled: $data.isLoading,
                class: "translate-dialog__button",
                onClick: $options.handleTranslate
              }, _createSlots({
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString($data.isLoading ? $options.t('spreed', 'Translating') : $options.t('spreed', 'Translate')), 1)
                ]),
                _: 2
              }, [
                ($data.isLoading)
                  ? {
                      name: "icon",
                      fn: _withCtx(() => [
                        _createVNode(_component_NcLoadingIcon)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["disabled", "onClick"])
            ]),
            _createVNode(_component_NcRichText, {
              class: "translate-dialog__message translate-dialog__message-source",
              text: $props.message,
              arguments: $props.richParameters,
              "reference-limit": 0
            }, null, 8, ["text", "arguments"]),
            ($data.translatedMessage)
              ? (_openBlock(), _createBlock(_component_NcRichText, {
                  key: 0,
                  class: "translate-dialog__message translate-dialog__message-translation",
                  text: $data.translatedMessage,
                  arguments: $props.richParameters,
                  "reference-limit": 0
                }, null, 8, ["text", "arguments"]))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined,
    ($data.translatedMessage)
      ? {
          name: "actions",
          fn: _withCtx(() => [
            _createVNode(_component_NcButton, { onClick: $options.handleCopyTranslation }, {
              icon: _withCtx(() => [
                _createVNode(_component_IconContentCopy)
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Copy translated text')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["name"]))
}